<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateDialog">新增</el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
<!--        <el-button type="text" size="small" @click="openEditDialog(row)">编辑</el-button>-->
        <el-button type="text" size="small" @click="openChangeDialog(row)">变更</el-button>
        <el-button type="text" size="small" @click="openViewDialog(row)">详情</el-button>
        <el-button type="text" size="small" @click.stop="openChangeLog(row)">变更记录</el-button>
      </template>
    </avue-crud>
    <change-log-dialog
      :visible.sync="changeLogVisible"
      :records="changeLogRecords"
      :loading="changeLogLoading"
    />
    <stock-lease-create-dialog
      :visible.sync="createDialogVisible"
      :submitting="createSaving"
      :mode="dialogMode"
      :initial-data="dialogInitialData"
      @submit="handleCreateSubmit"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail, getChangeLog} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";
import ChangeLogDialog from "./components/ChangeLogDialog.vue";
import StockLeaseCreateDialog from "./components/StockLeaseCreateDialog.vue";
import { LEASE_STATUS_DICT, YES_NO_DICT } from "./const";

export default {
  components: { ChangeLogDialog, StockLeaseCreateDialog },
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove,getDetail},
      createDialogVisible: false,
      createSaving: false,
      dialogMode: 'create', // create | change | view
      viewData: {},
      changeData: {},
      changeLogVisible: false,
      changeLogLoading: false,
      changeLogRecords: [],
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        column: [
          {
            label: '租约名称',
            prop: 'leaseName',
            search: true, // 查询是否显示
            width:150
          },
          {
            label: '货主名称',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            search: true, // 查询是否显示
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select', // 接口统一换位这个
            props: {
              label: 'deptName',
              value: 'id'
            },
            span:8,
            width:150
          },
          {
            label: '租赁总面积（㎡）',
            prop: 'totalArea',
            width:140
          },
          {
            label: '租约状态',
            prop: 'leaseStatus',
            type: 'select',
            dicData: LEASE_STATUS_DICT,
          },
          // {
          //   label: '合同附件',
          //   prop: 'contractAttachment',
          // },
          {
            label: '是否自动续租',
            prop: 'autoRenew',
            type: 'select',
            dicData: YES_NO_DICT,
            width:140
          },
          {
            label: '提前通知期（天）',
            prop: 'reminderDays',
            width:150
          },
          {
            label: '提前1个月提醒是否已发送',
            prop: 'reminderSent',
            type: 'select',
            dicData: YES_NO_DICT,
            width:150
          },
          // {
          //   label: '备注',
          //   prop: 'remark',
          // },
          // {
          //   label: '创建人',
          //   prop: 'createUser',
          // },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 150,
          },
          {
            ...searchTimeConfig,
            // searchTimeConfig 默认 searchSpan:10 时 queryAutoArrange 仅给按钮区 2 格，会换行
            searchSpan: 6,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  computed: {
    dialogInitialData () {
      if (this.dialogMode === 'view') return this.viewData
      if (this.dialogMode === 'change') return this.changeData
      return {}
    }
  },
  methods: {
    openCreateDialog () {
      this.dialogMode = 'create'
      this.viewData = {}
      this.changeData = {}
      this.changeLogVisible = false
      this.createDialogVisible = true
    },
    async handleCreateSubmit (payload) {
      if (this.dialogMode === 'view') {
        this.createDialogVisible = false
        return
      }
      this.createSaving = true
      try {
        if (this.dialogMode === 'change') {
          await update({ ...payload, actionType: 'change' })
          this.$message.success('变更成功')
        } else {
          await add(payload)
          this.$message.success('新增成功')
        }
        this.createDialogVisible = false
        this.onLoad(this.page, this.query)
      } finally {
        this.createSaving = false
      }
    },
    openChangeDialog (row) {
      if (!row.id) {
        this.$message.warning('未找到记录ID')
        return
      }
      this.dialogMode = 'change'
      this.changeData = {}
      this.changeLogVisible = false
      this.createDialogVisible = true
      this.fetchDetail(row.id, 'change')
    },
    openViewDialog (row) {
      if (!row.id) {
        this.$message.warning('未找到记录ID')
        return
      }
      this.dialogMode = 'view'
      this.changeLogVisible = false
      this.createDialogVisible = true
      this.fetchDetail(row.id, 'view')
    },
    async fetchDetail (id, mode = 'change') {
      try {
        const res = await getDetail(id)
        const detail = res.data.data
        if (mode === 'view') this.viewData = detail || {}
        if (mode === 'change') this.changeData = detail || {}
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    async openChangeLog (row) {
      if (!row.leaseNo) {
        this.$message.warning('未找到对应的租约编号');
        return;
      }
      this.createDialogVisible = false; // 避免同时打开编辑/新增弹窗
      this.changeLogVisible = true;
      this.changeLogLoading = true;
      try {
        const res = await getChangeLog({ leaseNo: row.leaseNo });
        const data = (res.data && res.data.data) || {};
        this.changeLogRecords = data.records || [];
      } catch (error) {
        this.changeLogRecords = []
      } finally {
        this.changeLogLoading = false;
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
